import throttle from 'lodash/throttle';

//returns true if given element is in the view port
const isElementInViewport = el => {
	if(!el) {
		return false;
	}
	let rect = el.getBoundingClientRect(),
		vWidth = window.innerWidth || doc.documentElement.clientWidth,
		vHeight = window.innerHeight || doc.documentElement.clientHeight,
		efp = (x, y) => document.elementFromPoint(x, y);

	// Return false if it's not in the viewport
	if (rect.right < 0 || rect.bottom < 0
		|| rect.left > vWidth || rect.top > vHeight)
		return false;

	// Return true if any of its four corners are visible
	return (
		el.contains(efp(rect.left, rect.top))
		|| el.contains(efp(rect.right, rect.top))
		|| el.contains(efp(rect.right, rect.bottom))
		|| el.contains(efp(rect.left, rect.bottom))
	);
};


(() => {
	let scrollProgress = 0;
	let showAfter = 500;
	let scrollButtonEl = document.querySelector('#scroll-to-top');

	if (scrollButtonEl) {
		let updateButton = () => {
			scrollProgress = window.pageYOffset;
			if (scrollProgress > showAfter) {
				// check if footer elements appeared in the viewport and mobile (<992px) => hide scroll-to-top=
				if (isElementInViewport(document.querySelector('.footer__content')) && isElementInViewport(document.querySelector('.footer__copyright')) && document.documentElement.clientWidth < 992) {
					scrollButtonEl.classList.remove('scroll-to-top--shown');
				} else {
					scrollButtonEl.classList.add('scroll-to-top--shown');
				}
			} else {
				scrollButtonEl.classList.remove('scroll-to-top--shown');
			}
		};
		updateButton();

		window.addEventListener('scroll', throttle(updateButton, 200));

		scrollButtonEl.addEventListener('click', e => {
			e.preventDefault();
			window.scrollTo(0, 0);
		});
	}
})();
